import React, {useEffect, useState} from 'react';
import './CustomerInstallmentsTable.scss';
import {VisitSVG} from "../ExportSVG";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";

const CustomerInstallmentsTable = ({data, setDetailData, setStep}) => {

  const [componentData, setComponentData] = useState([])
  const [filter, setFilter] = useState({})

  useEffect(() => {
    setComponentData(data)
  }, [data]);

  const getDetailData = async (data) => {
    const response = await _axios.get(prefixUrl() + `/insurance/?request=insuranceCustomerInstallments&insuranceId=` + data?.insuranceId)
    if (response.data.status) {
      setDetailData({tableRow: data, data: response.data.data})
      setStep(2)
    }
  }

  const filterHandler = (value, name) => {
    filter[name] = value
    setFilter({...filter})
  }

  useEffect(() => {
    if (Object.keys(filter).length > 0) {
      let temp = data;
      for (const key in filter) {
        temp = temp.filter((item) => {
          return item[key]?.toString().includes(filter[key].toString());
        });
      }
      setComponentData(temp);
    } else {
      setComponentData(data);
    }
  }, [filter, data]);

  try {
    return (
      <div className={"table-installments"}>
        <ul>
          <li className={"header-class"}>
            <div style={{width: "5%"}}>ردیف</div>
            <div style={{width: "15%"}}>کد ملی</div>
            <div style={{width: "15%"}}>نوع بیمه نامه</div>
            <div style={{width: "20%"}}>شماره بیمه نامه</div>
            <div style={{width: "20%"}}>نام مشتری</div>
            <div style={{width: "20%"}}>عنوان سازمان</div>
            <div style={{width: "5%"}}>عملیات</div>
          </li>
          <li>
            <div style={{width: "5%"}}></div>
            <div style={{width: "15%"}}>
              <input onChange={(e) => filterHandler(e.target.value, "nationalId")}/>
            </div>
            <div style={{width: "15%"}}>
              <input onChange={(e) => filterHandler(e.target.value, "insuranceType")}/>
            </div>
            <div style={{width: "20%"}}>
              <input onChange={(e) => filterHandler(e.target.value, "insuranceNumber")}/>
            </div>
            <div style={{width: "20%"}}>
              <input onChange={(e) => filterHandler(e.target.value, "personName")}/>
            </div>
            <div style={{width: "20%"}}>
              <input onChange={(e) => filterHandler(e.target.value, "organizationName")}/>
            </div>
            <div style={{width: "5%"}}></div>
          </li>
        </ul>
        <ul className={"body-ul"}>
          {componentData?.length > 0 && componentData?.map((item, index) => (
            <li key={index + "row"}>
              <div style={{width: "5%"}}>{index + 1}</div>
              <div style={{width: "15%"}}>{item?.nationalId}</div>
              <div style={{width: "15%"}}>{item?.insuranceType}</div>
              <div style={{width: "20%"}}>{item?.insuranceNumber}</div>
              <div style={{width: "20%"}}>{item?.personName}</div>
              <div style={{width: "20%"}}>{item?.organizationName}</div>
              <div style={{width: "5%", cursor: 'pointer'}} onClick={() => getDetailData(item)}><VisitSVG/></div>
            </li>
          ))}
        </ul>
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default CustomerInstallmentsTable;